module.exports = __webpack_public_path__ + "img/services-modal-icon.d13785ea.svg";